import React, { lazy } from 'react';
import { HeartPulseIcon, LeafIcon, AlertCircleIcon, ArrowRightIcon } from 'lucide-react';
export function AuthorSection() {
  return <section className="w-full bg-emerald-50 py-16 md:py-24" data-id="element-35">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-36">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center mb-12" data-id="element-37">
          <div data-id="element-38">
            <div className="flex items-center gap-2 mb-4" data-id="element-39">
              <HeartPulseIcon className="w-6 h-6 text-emerald-700" data-id="element-40" />
              <span className="text-emerald-700 font-semibold" data-id="element-41">Your Guide</span>
            </div>
            <div className="flex items-center gap-3 mb-4" data-id="element-42">
              <LeafIcon className="w-8 h-8 text-emerald-700" data-id="element-43" />
              <h2 className="text-3xl md:text-4xl font-bold text-stone-900" data-id="element-44">
                Meet Emily Harper, RH
              </h2>
            </div>
            <p className="text-lg text-stone-700 mb-4" data-id="element-45">
              Registered Herbalist | Family Nutrition Specialist | Mom of 3
            </p>
            <p className="text-lg text-stone-700 mb-6 leading-relaxed" data-id="element-46">
              For 15 years, Emily has helped families, seniors, and busy parents
              treat everyday ailments naturally—using safe, proven herbal
              remedies you can make right in your kitchen.
            </p>
            <p className="text-lg text-stone-700 leading-relaxed" data-id="element-47">
              Her remedies have been featured in homesteading communities,
              naturopathic clinics, and family wellness workshops across the
              U.S.
            </p>
          </div>
          <div data-id="element-48">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rF6JCgcy3wEfrTnYRcAEat/Meet-Emily-Harper.png" alt="Emily Harper with Natural Remedy Guide" className="w-full h-auto rounded-lg shadow-xl" loading="lazy" data-id="element-49" />
          </div>
        </div>
        <div className="bg-white rounded-xl p-8 shadow-lg" data-id="element-50">
          <div className="flex items-center gap-3 mb-4" data-id="element-51">
            <AlertCircleIcon className="w-8 h-8 text-amber-600" data-id="element-52" />
            <h3 className="text-2xl font-bold text-stone-900" data-id="element-53">
              Her Crisis Moment
            </h3>
          </div>
          <div className="space-y-4 text-stone-700 leading-relaxed" data-id="element-54">
            <p data-id="element-55">
              Three winters ago, Emily's youngest daughter developed chronic
              sinus infections. Nothing worked—not antibiotics, not syrups, not
              expensive supplements.
            </p>
            <p data-id="element-56">Doctor after doctor prescribed the same medications with:</p>
            <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-57">
              <li data-id="element-58">no real improvement</li>
              <li data-id="element-59">no explanation</li>
              <li data-id="element-60">no long-term solution</li>
            </ul>
            <p data-id="element-61">
              At the same time, Emily's elderly mother was dealing with joint
              pain and sleep problems—again, the only answers were pills and
              more pills.
            </p>
            <p className="font-semibold text-stone-900 text-lg" data-id="element-62">
              Emily realized something shocking:
            </p>
            <div className="flex items-start gap-3 bg-emerald-50 p-4 rounded-lg" data-id="element-63">
              <ArrowRightIcon className="w-6 h-6 text-emerald-700 flex-shrink-0 mt-1" data-id="element-64" />
              <p className="text-xl font-bold text-emerald-700" data-id="element-65">
                The healthcare system wasn't trying to heal them. It was just
                treating symptoms.
              </p>
            </div>
            <p data-id="element-66">
              That was the turning point. She dove deep into herbalism, natural
              medicine, and historical remedies. She worked with herbalists,
              naturopaths, and holistic practitioners. She rebuilt her family's
              wellness—using remedies from her pantry, not the pharmacy.
            </p>
            <p className="font-semibold" data-id="element-67">
              Today, her kids are healthier than ever. Her mother sleeps through
              the night. Her clients rave about their results.
            </p>
          </div>
        </div>
      </div>
    </section>;
}